import { useState } from 'react';
import useIntersectionObserver from './useIntersectionObserver';
export function useInView(options, reverse = false, isEditMode = false) {
    const [inView, setInView] = useState(false);
    const [firstCheck, setFirstCheck] = useState(false);
    const { elementRef } = useIntersectionObserver((entries) => {
        /**
         * If element is above the fold on first check,
         * set inView to true to prevent empty space
         */
        if (!firstCheck) {
            setFirstCheck(true);
            if (entries[0].boundingClientRect.top < window.outerHeight) {
                setInView(true);
            }
        }
        if (entries[0].isIntersecting) {
            setInView(true);
        }
        else if (reverse === true) {
            setInView(false);
        }
    }, options);
    return [elementRef, isEditMode ? true : inView];
}
export function useWithInView(options, reverse = false, isEditMode = false) {
    const [inView, setInView] = useState(false);
    const [firstCheck, setFirstCheck] = useState(false);
    const { elementRef } = useIntersectionObserver((entries) => {
        /**
         * If element is above the fold on first check,
         * set inView to true to prevent empty space
         */
        if (!firstCheck) {
            setFirstCheck(true);
            console.log(entries[0].boundingClientRect, window.outerHeight);
            if (entries[0].boundingClientRect.bottom < window.outerHeight && entries[0].boundingClientRect.top > 200) {
                setInView(true);
            }
        }
        if (entries[0].boundingClientRect.bottom < window.outerHeight && entries[0].boundingClientRect.top > 200) {
            setInView(true);
        }
        else {
            setInView(false);
        }
    }, options);
    return [elementRef, isEditMode ? true : inView];
}
